import React, { ReactNode } from 'react';
import * as css from './list.module.scss';
import classNames from 'classnames';

interface UnorderedListProps extends React.HTMLAttributes<HTMLUListElement> {
  children: ReactNode;
}

export const UnorderedList = ({
  children,
  className,
  ...props
}: UnorderedListProps) => {
  return (
    <ul {...props} className={classNames(css.list, css.unordered, className)}>
      {children}
    </ul>
  );
};

interface OrderedListProps extends React.OlHTMLAttributes<HTMLOListElement> {
  children: ReactNode;
}

export const OrderedList = ({
  children,
  className,
  ...props
}: OrderedListProps) => {
  return (
    <ol {...props} className={classNames(css.list, css.ordered, className)}>
      {children}
    </ol>
  );
};

interface ListItemProps extends React.HTMLAttributes<HTMLLIElement> {
  children: ReactNode;
}

/* Added for simple addition of common behaviour, if needed later */
export const ListItem = ({ children, ...props }: ListItemProps) => (
  <li {...props}>{children}</li>
);
